import Tab from './components/Tab'

const Tabs = ({children}: {children: React.ReactNode}) => {
    return (
        <div className="grid grid-flow-col rounded-full ring-2 ring-inset ring-yellow-40">
            {children}
        </div>
    )
}

Tabs.Tab = Tab

export default Tabs
